import { Icon } from '@chakra-ui/react'
import React from 'react'
import { FaArrowDown, FaArrowUp } from 'react-icons/fa'

export function OrderBy({ orderBy, name }) {
    const [toggleOrder, setToggleOrder] = React.useState(false)

    function handleOrderBy() {
        setToggleOrder(!toggleOrder)
        orderBy({ ordem: name, ordenacao: toggleOrder ? 'asc' : 'desc' })
    }

    return <Icon as={toggleOrder ? FaArrowDown : FaArrowUp} onClick={handleOrderBy} cursor="pointer" color="gray.100" w={4} h={4} />
}
